<template>
  <section class="ma-4 ma-md-8">
    <t-page-title title="Edição de Cupom" />
    <v-row justify="center" align="center">
      <v-col>
        <v-card v-if="model" class="pa-8">
          <form-coupon v-model="model" editing @submit="submit" />
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import Coupon from '@/types/Coupon'
import { useLoader } from '@/stores/loader'
import { useSnackBar } from '@/stores/snackbar'
import { useRouter } from 'vue-router'
import CouponService from '@/services/CouponService'
import TPageTitle from '@/components/TPageTitle.vue'
import FormCoupon from './form-coupon.vue'

const loader = useLoader()
const snackbar = useSnackBar()
const router = useRouter()

const service = new CouponService()

const model = ref<Coupon>()

async function fetch() {
  try {
    loader.increment()
    const { data } = await service.show(router.currentRoute.value.params.id as string)

    model.value = data.data
  } catch (error) {
    snackbar.show(
      'Não foi possível buscar o cupom',
      'error',
    )
    throw error
  } finally {
    loader.decrement()
  }
}

async function submit(model: Coupon, users: { assigned: string[], unassigned: string[] }) {
  try {
    loader.increment()
    await service.update(router.currentRoute.value.params.id as string, model, users)

    snackbar.show(
      'Cuom atualizado com sucesso',
      'success',
    )

    router.push({ name: 'list-coupons' })
  } catch (error) {
    snackbar.show(
      'Não foi possível atualizar o cupom',
      'error',
    )

    throw error
  } finally {
    loader.decrement()
  }
}

onMounted(() => fetch())

</script>
